import { Skeleton } from "@/components/ui/skeleton"

export default function ServicesGridSkeleton() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-2">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="p-6 rounded-2xl border border-gray-100  bg-white flex flex-col items-center gap-4">
          <Skeleton className="w-16 h-16 rounded-full" />
          <div className="flex flex-col items-center gap-2 w-full">
            <Skeleton className="h-5 w-3/4 rounded-md" />
            <Skeleton className="h-3 w-1/2 rounded-md" />
          </div>
        </div>
      ))}
    </div>
  )
}


